// cspell:words wordprocessingml
export const mockData = [
  {
    id: 'photo-1497752531616-c3afd9760a11',
    name: 'Image 1',
    description: 'Descriptive text about Image 1',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1497752531616-c3afd9760a11?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80'
  },
  {
    id: 'pdf-1',
    name: 'Sample-PDF 1',
    description: 'Descriptive text about Dictionary of old Icelandic',
    src: 'https://css4.pub/2015/icelandic/dictionary.pdf',
    format: 'pdf'
  },
  {
    id: 'video-1',
    name: 'Pega video',
    description: 'Descriptive text about Video',
    format: 'mp4',
    src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'
  },
  {
    id: 'audio-1',
    name: 'Pega audio',
    description: 'Descriptive text about Audio',
    format: 'mp3',
    src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
  },
  {
    id: 'doc1',
    name: 'Pega.docx',
    description: 'Descriptive text about Pega document',
    format: 'docx',
    src: null
  },
  {
    id: 'photo-1470093851219-69951fcbb533',
    name: 'Image 2',
    description: 'Descriptive text about Image 2',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1470093851219-69951fcbb533?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80'
  },
  {
    id: 'photo-1447684808650-354ae64db5b8',
    name: 'Image 3',
    description: 'Descriptive text about Image 3',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1447684808650-354ae64db5b8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2094&q=80'
  },
  {
    id: 'photo-1425082661705-1834bfd09dca',
    name: 'Image 4',
    description: 'Descriptive text about Image 4',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1425082661705-1834bfd09dca?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2110&q=80'
  },
  {
    id: 'photo-1494256997604-768d1f608cac',
    name: 'Image 5',
    description: 'Descriptive text about Image 5',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1494256997604-768d1f608cac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2301&q=80'
  },
  {
    id: 'photo-1500694216671-a4e54fc4b513',
    name: 'Image 6',
    description: 'Descriptive text about Image 6',
    format: 'jpeg',
    src: 'https://images.unsplash.com/photo-1500694216671-a4e54fc4b513?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2092&q=80'
  },
  {
    id: 'ppt2',
    name: 'Pega.odp',
    description: 'Descriptive text about Presentation file',
    format: 'odp',
    src: null
  },
  {
    id: 'attachment_link',
    name: 'Link file',
    description: 'Descriptive text about Image 7',
    format: 'url',
    src: 'https://images.unsplash.com/photo-1638292597251-6fe6b2ba50f9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80'
  },
  {
    id: 'generic',
    name: 'Pega file',
    description: 'Descriptive text about file',
    format: '3ds',
    src: null
  },
  {
    id: 'error',
    name: 'Pega file',
    description: 'Error showing content',
    format: 'jpeg',
    // invalid url
    src: 'https://images.unsplash.com/photo'
  },
  {
    id: 'item-1',
    name: 'Pega file',
    description: 'Descriptive text',
    format: undefined,
    src: null
  }
];

export const mockBadResources = [
  {
    id: 'image-error',
    name: 'Some image',
    description: 'Descriptive text about Some image',
    src: '',
    format: undefined,
    error: true
  }
];
